export const API_URL = "https://develop.mcdo-gamecenter-wrapper.makemepulse.dev/api";


export function GetUser(token: string, domain: string) {
  return fetch(`${API_URL}/user`, { headers: { Authorization: `Bearer ${token}`, "X-domain": domain } })
}